import { defineElement, gsapWithCSS } from "./gw.js";
class CollapsibleContent extends HTMLElement {
  constructor() {
    super();
    this.onTimelineStart = this.onTimelineStart.bind(this);
    this.onTimelineComplete = this.onTimelineComplete.bind(this);
    this.onTimelineReverseStart = this.onTimelineReverseStart.bind(this);
    this.onTimelineReverseComplete = this.onTimelineReverseComplete.bind(this);
    this.init();
  }

  init() {
    this.content = this.firstElementChild;
    this.buildTimeline();
    if (this.getAttribute("aria-hidden") === "true") {
      this.collapsed = true;
    } else {
      this.timeline.progress(1);
    }
  }

  get collapsed() {
    return (
      this.hasAttribute("collapsed") &&
      this.getAttribute("collapsed") !== "false"
    );
  }

  set collapsed(value) {
    if (value) {
      this.setAttribute("collapsed", "");
    } else {
      this.removeAttribute("collapsed");
    }
  }

  get expanded() {
    return !this.collapsed;
  }

  onTimelineStart() {
    this.removeAttribute("collapsed");
    this.setAttribute("aria-hidden", "false");
  }

  onTimelineComplete() {
    gsapWithCSS.set(this.content, {
      clearProps: "all",
    });
  }

  onTimelineReverseStart() {
    this.setAttribute("collapsed", "");
  }

  onTimelineReverseComplete() {
    this.setAttribute("aria-hidden", "true");
    gsapWithCSS.set(this.content, {
      clearProps: "all",
    });
  }

  buildTimeline() {
    this.timeline = gsapWithCSS
      .timeline({
        paused: true,
        onStart: this.onTimelineStart,
        onComplete: this.onTimelineComplete,
        onReverseComplete: this.onTimelineReverseComplete,
      })
      .fromTo(
        this.content,
        {
          height: 0,
          autoAlpha: 0,
        },
        {
          height: "auto",
          autoAlpha: 1,
          duration: 0.4,
          ease: "power2.inOut",
        },
      );
  }

  show() {
    this.timeline.play();
  }

  hide() {
    this.onTimelineReverseStart();
    this.timeline.reverse();
  }

  toggle() {
    if (this.expanded) {
      this.hide();
    } else {
      this.show();
    }
    return this.expanded;
  }
}
defineElement("collapsible-content", CollapsibleContent);
class CollapsibleContentTrigger extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector("button");
    this.onClick = this.onClick.bind(this);
  }

  connectedCallback() {
    this.initTarget();
    this.button.addEventListener("click", this.onClick);
  }

  disconnectedCallback() {
    this.button.removeEventListener("click", this.onClick);
  }

  get target() {
    const targetSelector = this.getAttribute("target");
    if (!targetSelector) return null;
    return document.querySelector(targetSelector);
  }

  initTarget() {
    var _a;
    const target = this.target;
    if (!target) return;
    if (
      !target.hasAttribute("id") &&
      ((_a = self == null ? void 0 : self.crypto) == null
        ? void 0
        : _a.randomUUID)
    ) {
      target.id = `CollapsibleContent-${self.crypto.randomUUID()}`;
    }
    this.button.setAttribute("aria-controls", target.id);
    this.button.setAttribute("aria-expanded", target.expanded ?? false);
  }

  onClick() {
    const target = this.target;
    if (!target) return;
    const expanded = target.toggle();
    this.button.setAttribute("aria-expanded", expanded);
  }
}
defineElement("collapsible-content-trigger", CollapsibleContentTrigger);
export { CollapsibleContentTrigger };
